import { DrawerBase } from './DrawerBase';

import { GAME_MODES } from '../constats';
import { GAME_MODE } from '../../stateManagment/gameState';

export class BaseParentControlDrawer extends DrawerBase {
  constructor(applications) {
    super();
    this.applications = applications;
  }

  execute(mode, config = {}) {
    return this.applications[mode]
      .execute(config);
  }

  get application() {
    return this.applications[GAME_MODE.getValue()];
  }

  getApplication(mode) {
    return this.applications[mode];
  }

  get mobileApplication() {
    return this.applications[GAME_MODES.MOBILE];
  }

  get webApplication() {
    return this.applications[GAME_MODES.DESKTOP];
  }

  get landscapeApplication() {
    return this.applications[GAME_MODES.MOBILE_LANDSCAPE];
  }
}
